import axios from 'Axios';
import Vue from 'vue';

const accountInfo = {
	state: {
		yearPeriods: '',
		accountInfoData: '',
		subjectListData:'',  //科目列表
		foreignCurrencyData:'',
    	isPrivateNop:false, //是否 民办非
    	superPreventOperation:"",
		areaList:[], 
		//accountInfoCode: true,
	},
	mutations: {
		SET_AREA_LIST:(state,view)=>{
			state.areaList = view
		},
		GET_ALL_YEAR_PERIODS: (state , view)=>{
			state.yearPeriods = view;
		},
		GET_ACCOUNT_INFO: (state , view)=>{
			state.accountInfoData = view
		},
		GET_ACCOUNT_INFOS: (state , view)=>{
			state.superPreventOperation = view
		},
		GET_SUBJECT_INFO: (state , view)=>{
			state.subjectListData = view
		},
		GET_FORENCURRENCY_INFO: (state , view)=>{
			state.foreignCurrencyData = view
		},
		CLEAR_YEARPERIODS_INFO: (state)=>{
			state.yearPeriods = '';
		},
    GET_IS_PRIVATE_NOPROFIT:(state,bol)=>{
      state.isPrivateNop = bol;
    },
		// GET_ACCOUNT_INFO_CODE:(state,view)=>{
		// 	state.accountInfoCode = view;
		// },
	},
	actions: {
		// 获取账套信息
		getAccountInfo({commit},params) {
			return new Promise((resolve, reject) => {
				axios.post('createAccountSet/getBook',{}).then(res=>{
					if(res.data.code == '1') {
						commit('GET_ACCOUNT_INFO' , res.data.data);
						commit('GET_ACCOUNT_INFOS' , res.data.msg);
						//commit('GET_ACCOUNT_INFO_CODE' , true);
						console.log('1')
						sessionStorage.setItem('accountInfo', JSON.stringify(res.data.data));
						sessionStorage.setItem('superPreventOperation', JSON.stringify(res.data.msg));
						resolve(res.data.data)
						//return res.data.data;
					}else {
						reject()
						//commit('GET_ACCOUNT_INFO_CODE' , false);
					}
				})
			})
		},
		// 获取会计期间
		async getAllYearPeriodsData({commit},params) {
			let res = await axios.post('voucherChief/getAccountingPeriod',{}).then(res=>{
				if(res.data.code == '1') {
					commit('GET_ALL_YEAR_PERIODS' , res.data.data)
					sessionStorage.setItem('getAllYearPeriodsData', JSON.stringify(res.data.data));
					return res.data.data;
				}
			})
      return res
		},
		//获取科目
		getSujectAuxiliaryByType({commit},params){
			axios.post('subject/getSujectByContent',{}).then(res=>{
				if(res.data.code == '1') {
					commit('GET_SUBJECT_INFO' , res.data.data)
					return res.data.data;
				}
			})
		},
		//获取外币核算
		getForagenCurraryList({commit},params){
      
			axios.post('foreignCurrency/findAll',{}).then(res=>{
				if(res.data.code == '1') {
					commit('GET_FORENCURRENCY_INFO' , res.data.data)
					return res.data.data;
				}
			})
		},

    //是否 民办非
    getIsPrivateNonProfit({commit},params){
      return new Promise((resolve, reject) => {
        axios.post('createAccountSet/isPrivateNonProfit',{}).then(res=>{
        	if(res.data.code == '1') {
        		commit('GET_IS_PRIVATE_NOPROFIT' , res.data.data);
            resolve(res.data.data);
        		//return ;
        	}else {
            reject();
          }
        })
      })
    }
	}
}

export default accountInfo



// WEBPACK FOOTER //
// ./src/store/modules/accountInfo.js